<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">


			<li>
				<span>1、Your Ref.</span>
				<span>{{dataList.jz001}}</span>
			</li>
			<li>
				<span>2、Name of cargo</span>
				<span>{{dataList.jz002}}</span>
			</li>
			<li>
				<span>3、Are there serious problems regarding condition of the vessel?</span>
				<span v-if="dataList.jz003=='YES'">{{dataList.jz00301}}</span>
			</li>
			<li>
				<span>4、Inspect date</span>
				<span>{{dataList.jz004}}</span>
			</li>
			<li>
				<span>5、Ship's name (For example: MV."VENTURE LUCK")</span>
				<span>{{dataList.jz005}}</span>
			</li>
			<li>
				<span>6、LOT No. (Non-must fill) <i v-if="dataList.jz006">(For example:on the No.1 lot)</i> </span>
				<span>{{dataList.jz006}}</span>
			</li>
			<li>
				<span>7、Contract No. (Non-must fill) <i v-if="dataList.jz007">(For example: of Contract No.SWHR200061)</i> </span>
				<span>{{dataList.jz007}}</span>
			</li>
			<li>
				<span>8、Total Quantity of packages/tons(For example:60coils/475.955mt)</span>
				<span>{{dataList.jz008}}</span>
			</li>
			<li>
				<span>9、Port(For example:Zhangjiagang port, China)</span>
				<span>{{dataList.jz009}}</span>
			</li>
			<li>
				<span>10、Stacking description:(For example:All of cargoes were stored with 1 to 2 tiers height in the warehouse of Zhangjiagang port）</span>
				<span>{{dataList.jz010}}</span>
			</li>
			<li>
				<span>11、Package condition description:(For example:The coils of steel coils appeared to be machine-strapped and tied tightly with 6 lashing bands.Each coil have two shipping mark labels, the label showing the Manufacture name/ProductName/ Coils No./Heat No./Standard/Size/User/Inner Diameter/Product Date/Plant/PackingMode/ Grade/Edge State/Weight/Order/Checker/Country.）</span>
				<span>{{dataList.jz011}}</span>
			</li>
			<li>
				<span>12、Description of cargo condition:(For example:1. All the cargoes were stored in the warehouse before shipment.2. Rusted stained on the surface slightly and partly.3. Scratched on the surface slightly and partly.4. 1-2 pcs strapping bands broken/loose/missing. ）</span>
				<span>{{dataList.jz012}}</span>
			</li>
			<li>
				<span>13、Silver nitrate test (Non-must fill)</span>
				<div v-if="dataList.jz013" style="color: #fff !important;">
					Silver nitrate test
					<p style="color: #fff !important;">
						The silver nitrate solution test was performed to the rust parts of the steel coils at random with please select result noted.
					</p>
				</div>
				<span>{{dataList.jz013}}</span>
			</li>
			<li>
				<span>14、Site-related pictures and instructions</span>
				<div class="imgs" v-if="dataList.jz014">
					<span v-for="(item, index) in dataList.jz014.split('|')">
						<img style="background: #fff;" :src="item.split('!')[0]"  />
						<div style="color: #fff;">
							{{item.split('!')[1]}}
						</div>
					</span>

				</div>
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'ly',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulely(this.$route.query.scheduleId);
		}
	},
	methods: {
		getSchedulely(scheduleId) {
			let data = {
				id: this.id,
				scheduleId:scheduleId
			};
			this.$api.jz0(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
					// if (res.data.ly026) {
					// 	if (this.getSuffix(res.data.ly026) == 'pdf') {
					// 		this.num = 1;
					// 	} else {
					// 		this.num = 0;
					// 	}
					// }
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
